import styled, { css } from 'styled-components';
import { IGutterProps, SPACE_DEFAULT, useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import { IColoursCollection } from '../../fundamentals/colours/colourInterfaces';
import { PX_TO_REM } from '../../fundamentals/sizes/sizes';
import { BaseHr, BaseSpan } from '../../common/BaseElements';

export const dividerColours = ({ base, palette }: IColoursCollection) => ({
  dividerColours: {
    default: {
      background: palette.neutral300
    },
    white: {
      background: base.white.colour
    },
    light: {
      background: palette.neutral100
    }
  }
});

export type DividerPadding = 8 | 16 | 24 | 32;

export interface IDividerProps extends IGutterProps {
  white?: boolean;
  light?: boolean;
  pad?: boolean | DividerPadding;
}

const useDividerColourCss = css<IDividerProps>`
  background: ${({ theme, white, light }) => {
    const selector = light ? `light` : `default`;
    return theme.dividerColours[white ? `white` : selector].background;
  }};
`;

export const HR = styled(BaseHr)<IDividerProps>`
  border: 0;
  height: ${PX_TO_REM[1]};

  ${({ pad }) =>
    useGutterAsMarginCss(
      pad
        ? {
            left: pad === true ? SPACE_DEFAULT : pad,
            right: pad === true ? SPACE_DEFAULT : pad
          }
        : undefined
    )}

  ${useDividerColourCss};
`;

export const VR = styled(BaseSpan)<IDividerProps>`
  border: 0;
  width: ${PX_TO_REM[1]};

  ${({ pad, theme }) => {
    if (!pad) {
      return css`
        height: 100%;
      `;
    }

    const space = theme.spaces[pad === true ? SPACE_DEFAULT : pad];
    return css`
      height: calc(100% - ${space} - ${space});
    `;
  }};

  display: inline-flex;

  ${useDividerColourCss};

  ${({ pad }) =>
    useGutterAsMarginCss(
      pad
        ? {
            top: pad === true ? SPACE_DEFAULT : pad,
            bottom: pad === true ? SPACE_DEFAULT : pad
          }
        : undefined
    )}
`;

export const BrandedDivider = styled(BaseHr)<IDividerProps>`
  border: 0;
  height: ${PX_TO_REM[4]};
  background: ${({ theme }) => theme.colours.primary.colour};

  ${({ pad }) =>
    useGutterAsMarginCss(
      pad
        ? {
            left: pad === true ? SPACE_DEFAULT : pad,
            right: pad === true ? SPACE_DEFAULT : pad
          }
        : undefined
    )}
`;
